export default __webpack_public_path__ + "static/media/PropertyDev_Shapes-01-6.d1c68a81.svg";